<template>
  <SectionContainer v-if="books.length" class="fluid-x">
    <SectionHeader>
      <b slot="title">E-books</b>
      <span slot="subtitle">Material exclusivo com dicas, guias e fórmulas essenciais</span>
    </SectionHeader>

    <HorizontalCarousel :items="books" :options="{ fixedWidth: '9.16rem'}">
      <template v-slot="{ item }">
        <BookItem :book="item"/>
      </template>
    </HorizontalCarousel>
  </SectionContainer>
</template>

<script>
  import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'
  import { getAllBooks } from '@/api/book.api'
  import SectionContainer from '@/components/layout/SectionContainer'
  import SectionHeader from '@/components/layout/SectionHeader'
  import BookItem from '@/components/book/BookItem'

  export default {
    components: {
      SectionContainer,
      SectionHeader,
      BookItem,
      HorizontalCarousel
    },

    data: () => ({
      books: []
    }),

    mounted () {
      this.fetchBooks()
    },

    methods: {
      async fetchBooks () {
        const response = await getAllBooks()
        this.books = response.data
      }
    }
  }
</script>
